import dataVisPageAnalyticsLight from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-page-analytics-light.png";
import dataVisSingleColorChartsLight from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-single-color-charts-light.png";
import dataVisColorRoleDo from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-color-role-do.png";
import dataVisColorRoleDont from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-color-role-dont.png";
import dataVisCategoricalChartLight from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-categorical-chart-light.png";
import dataVisCategoricalDo from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-categorical-do.png";
import dataVisCategoricalDont from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-categorical-dont.png";
import dataVisStatusSeverityLight from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-status-severity-light.png";
import dataVisCustomChartColorsLight from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-custom-chart-colors-light.png";
import dataVisChartDataLight from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-chart-data-light.png";
import dataVisAdjacentColorDoLight from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-adjacent-color-do-light.png";
import dataVisAdjacentColorDontLight from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-adjacent-color-dont-light.png";
import dataVisTextChartsDo from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-text-charts-do.png";
import dataVisTextChartsDont from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-text-charts-dont.png";
import dataVisLineChartDo from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-line-chart-do.png";
import dataVisLineChartDont from "../../../../src/pages/foundations/color-new/data-visualization-color/_assets/data-vis-line-chart-do.png";
import { BrandAndNeutralChartTokensTable, CategoricalChartTokensTable, SemanticChartTokensTable } from '@af/design-system-docs-ui';
import * as React from 'react';
export default {
  dataVisPageAnalyticsLight,
  dataVisSingleColorChartsLight,
  dataVisColorRoleDo,
  dataVisColorRoleDont,
  dataVisCategoricalChartLight,
  dataVisCategoricalDo,
  dataVisCategoricalDont,
  dataVisStatusSeverityLight,
  dataVisCustomChartColorsLight,
  dataVisChartDataLight,
  dataVisAdjacentColorDoLight,
  dataVisAdjacentColorDontLight,
  dataVisTextChartsDo,
  dataVisTextChartsDont,
  dataVisLineChartDo,
  dataVisLineChartDont,
  BrandAndNeutralChartTokensTable,
  CategoricalChartTokensTable,
  SemanticChartTokensTable,
  React
};